<template>
    <div>
        <horizontal-stack>
            <span v-if="includeProduct">{{ $t('product.name') }}</span>
            <span>{{ regionText }}</span>
            <span class="tier">{{ tierText }}</span>
            <glyph-icon v-if="subscriptionTier === SubscriptionTier.Pro" :type="GlyphType.Pro" />
        </horizontal-stack>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { SubscriptionTier, GlyphType } from '../composables/useConstants';
import HorizontalStack from '../layout/HorizontalStack.vue';
import GlyphIcon from '../icons/glyphs/GlyphIcon.vue';

const { t, te } = useI18n();

const props = defineProps({
    subscriptionTier: {
        type: String,
        required: true,
    },
    region: {
        type: String,
        required: true,
    },
    includeProduct: {
        type: Boolean,
        default: false,
    },
});

const regionText = computed(() => {
    return props.region ? t(`region.${props.region}_short`) : '';
});

const tierText = computed(() => {
    const key = `subscription.tier.${props.subscriptionTier}`;
    return te(key) ? t(key) : '';
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
.horizontal-stack {
    gap: Pathfinder.$space-50;
    align-items: center;

    .tier {
        color: var(--selection-alt);
    }

    .glyph-container {
        fill: var(--selection-alt);

        // Use 1em so that the SVG acts like a typography character and automatically inherits the font-size
        height: 1em;
        width: 1em;
    }
}
</style>
